import{ThemeEvents,VariantUpdateEvent}from'@theme/events';
import{Component}from'@theme/component';
class ProductPrice extends Component{
connectedCallback(){super.connectedCallback();const s=this.closest('.shopify-section, dialog');if(!s)return;s.addEventListener(ThemeEvents.variantUpdate,this.updatePrice);}
disconnectedCallback(){super.disconnectedCallback();const s=this.closest('.shopify-section, dialog');if(!s)return;s.removeEventListener(ThemeEvents.variantUpdate,this.updatePrice);}
updatePrice=(e)=>{
if(e.detail.data.newProduct)this.dataset.productId=e.detail.data.newProduct.id;
else if(e.target instanceof HTMLElement&&e.target.dataset.productId!==this.dataset.productId)return;
const{priceContainer,volumePricingNote}=this.refs;
const n=e.detail.data.html.querySelector(`product-price[data-block-id="${this.dataset.blockId}"]`);
if(!n)return;
const np=n.querySelector('[ref="priceContainer"]');
if(np&&priceContainer)priceContainer.replaceWith(np);
const nn=n.querySelector('[ref="volumePricingNote"]');
if(!nn)volumePricingNote?.remove();
else if(!volumePricingNote)np?.insertAdjacentElement('afterend',nn.cloneNode(true));
else volumePricingNote.replaceWith(nn);
const i=this.querySelector(`#product-form-installment-${this.dataset.blockId} input[name="id"]`);
if(i){i.value=e.detail.resource?.id??'';i.dispatchEvent(new Event('change',{bubbles:true}));}
};
}
if(!customElements.get('product-price'))customElements.define('product-price',ProductPrice);